import { makeAutoObservable } from 'mobx'

/**
 * @class RecruitmentStore
 * @description This class represents the store for recruitment. It manages the state of recruitment and is part of the root store.
 */
class RecruitmentStore {
	/**
	 * @property {Object} recruitment - An object containing recruitment indexed by their IDs.
	 */
	recruitment = {}

	/**
	 * @constructor
	 * @param {Object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of RecruitmentStore and makes it observable.
	 */
	constructor(rootStore) {
		this.rootStore = rootStore
		makeAutoObservable(this)
	}
}

export default RecruitmentStore
